/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit'

import { EChannel } from '@/libs/actions/auth/auth-actions.type'

export const initialState = {
  username: '',
  tokenVerifier: '',
  attempt: 0,
  channel: EChannel.WHATSAPP,
  maskedPhoneNumber: '',
  isRateLimitReached: false,
  isInputRateLimitReached: false,
  // rateLimitLockedTime will remove and change to remainingTime after adjustment from BE is ready
  remainingTime: 0,
  rateLimitLockedTime: 0,
  lastResendAttemptTime: 0,
  error: '',
}

const phoneOtp = createSlice({
  name: 'phoneOtp',
  initialState,
  reducers: {
    setSubmitOtpError: (state, action) => {
      state.error = action.payload
    },
    setLastResendAttemptTime: (state, action) => {
      state.lastResendAttemptTime = action.payload
    },
    setRateLimitLockedTime: (state, action) => {
      state.rateLimitLockedTime = action.payload
    },
    setRateLimitReached: (
      state,
      action: { payload: { isRateLimitReached: boolean; remainingTime?: number } },
    ) => {
      state.isRateLimitReached = action.payload.isRateLimitReached
      state.remainingTime = action.payload.remainingTime ?? 0
    },
    setOtpMaskedPhoneNumber: (state, action) => {
      state.maskedPhoneNumber = action.payload
    },
    setOtpUsername: (state, action) => {
      state.username = action.payload
    },
    setOtpTokenVerifier: (state, action) => {
      state.tokenVerifier = action.payload
    },
    setOtpUsernameAttempt: (state, action) => {
      state.attempt = action.payload
    },
    setOtpUsernameChannel: (state, action) => {
      state.channel = action.payload
    },
    setIsInputRateLimitReached: (state, action) => {
      state.isInputRateLimitReached = action.payload
    },
    resetOtpPhone: () => {
      return initialState
    },
  },
})

export const {
  resetOtpPhone,
  setOtpUsername,
  setOtpUsernameAttempt,
  setOtpUsernameChannel,
  setOtpTokenVerifier,
  setOtpMaskedPhoneNumber,
  setRateLimitReached,
  setRateLimitLockedTime,
  setLastResendAttemptTime,
  setSubmitOtpError,
  setIsInputRateLimitReached,
} = phoneOtp.actions

export default phoneOtp.reducer
